import { Component, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { Router } from '@angular/router';
import { process, State } from '@progress/kendo-data-query';
import { CRMService } from '../../services/crm.service';
import { CSEService } from '../../services/cse.service';
import { EmailService } from '../../services/email.service';
import { EncryptionService } from '../../services/encryption.service';
import { ERPService } from '../../services/erp.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import {
    CarrierDropReason
    , CarrierList
    , Mode
    , Offer
    , RateIndex
    , SearchCarrierSalesBookedLoads
    , TrailerType
} from '../../models/models';

@Component({
    selector: 'carrier-sales-lanes-loads-grid',
    templateUrl: './carrier-sales-lanes-loads-grid.component.html',
    standalone: false
})
export class CarrierSalesLanesLoadsGrid implements OnInit, OnChanges {
    @Input() loads: SearchCarrierSalesBookedLoads[] = [];
    //@Input() viewType: string = "booked";
    @Input() selectedLoad: SearchCarrierSalesBookedLoads = {} as SearchCarrierSalesBookedLoads;
    @Output() onClick = new EventEmitter<any>();
    @Output() onRemoveCarrier = new EventEmitter<any>();
    //@Output() onOfferClick = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public carriersGrid!: GridComponent;

    public isLoading: boolean = false;
    public isValid: boolean = false;
    public carriersOrig: CarrierList[] = [];
    public carriers: CarrierList[] = [];
    public isCarrierRepsAssigned: boolean = false;

    // Carrier Sales Reps Assigned dialog fields
    public quoteOrderLineID: number = 0;
    public assignedLoad: SearchCarrierSalesBookedLoads = {} as SearchCarrierSalesBookedLoads;
    public removeCarrierOffer: Offer = {} as Offer;
    public carrierDropReasonList: CarrierDropReason[] = [];
    public modeList: Mode[] = [];
    public trailerTypeList: TrailerType[] = [];
    public rateIndexList: RateIndex[] = [];

    //private originCity: City = {} as City;
    //private destinationCity: City = {} as City;
    public originCityID: number = 0;
    public destinationCityID: number = 0;
    public modeID: number = 0;
    public trailerTypeID: number = 0;
    public rateIndexID: number = 0;
    public isRoundTrip: boolean = false;

    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'confidenceRanking' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    //public originCityControl = new UntypedFormControl();
    //public destinationCityControl = new UntypedFormControl();
    //public carrierLaneForm: UntypedFormGroup = new UntypedFormGroup({
    //    originCityControl: new UntypedFormControl(''),
    //    destinationCityControl: new UntypedFormControl('')
    //});

    public carrierLaneForm: UntypedFormGroup = new UntypedFormGroup({
        originCityControl: new UntypedFormControl(''),
        destinationCityControl: new UntypedFormControl('')
    });

    constructor(public crmService: CRMService, public cseService: CSEService, public emailService: EmailService,
        public encryptionService: EncryptionService, public erpService: ERPService, private notificationService: NotificationService,
        public orderService: OrderService, private ngZone: NgZone, private router: Router) {
    }

    ngOnInit() {
        this.getModes();
        this.getTrailerTypes();
        this.getRateIndexes();
    }

    ngOnChanges() {
    }

    private getTrailerTypes() {
        this.orderService.getTrailerTypes().subscribe(result => {
            this.trailerTypeList = result;
            this.trailerTypeList = this.trailerTypeList.filter(t => t.allowedOnLanes == true);
        });
    }

    private getModes() {
        this.orderService.getModes().subscribe(result => {
            this.modeList = result;
        });
    }

    private getRateIndexes() {
        this.crmService.getRateIndices().subscribe(result => {
            this.rateIndexList = result;
            var idx = this.rateIndexList.findIndex(t => t.description == "Spot")!;
            if (idx >= 0) {
                this.rateIndexID = this.rateIndexList[idx].rateIndexID;
            }
        });
    }

    public laneCitySet(evt: any, cityType: string) {
        if (cityType == "origin") {
            this.originCityID = evt;
            //this.originCity = this.carrierLaneForm.controls['originCityControl'].value as City;
        }
        else if (cityType == "destination") {
            this.destinationCityID = evt;
            //this.destinationCity = this.carrierLaneForm.controls['destinationCityControl'].value as City;
        }
        this.validateForm();
    }

    public validateForm() {
        //if (this.originCity.cityId && this.destinationCity.cityId && this.modeID > 0 && this.trailerTypeID > 0 && this.rateIndexID > 0) {
        //    this.isValid = true;
        //}
        console.log("carrier-sales-lanes-loads:validateForm", this.originCityID, this.destinationCityID, this.modeID, this.trailerTypeID);
        if (this.originCityID > 0 && this.destinationCityID > 0 && this.modeID > 0 && this.trailerTypeID > 0 && this.rateIndexID > 0) {
            this.isValid = true;
        }
        else {
            this.isValid = false;
        }
    }

    public getCarriersByLane() {
        console.log("getCarriersByLane", this.originCityID, this.destinationCityID, this.modeID, this.trailerTypeID, this.rateIndexID, this.isRoundTrip);
        this.isLoading = true;
        this.cseService.getCarriersByGeocodeLane(this.originCityID, this.destinationCityID, this.modeID, this.trailerTypeID, this.rateIndexID, this.isRoundTrip).subscribe(result => {
            this.isLoading = false;
            this.carriersOrig = result;
            this.setGrid();
        });
    }

    private setGrid() {
        this.carriers = Object.assign([], this.carriersOrig);
        this.gridData = process(this.carriers, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.carriersGrid == null) return;
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.carriers, this.gridState);
    }

    public rowCallback(context: RowClassArgs) {
        const isHighPriority = (context.dataItem.loadPriorityAbbreviation == "High");
        const isExpedite = (context.dataItem.rateIndex == "Expedite");
        if (isExpedite) {
            return {
                expedite: isExpedite
            }
        }
        else if (isHighPriority) {
            return {
                highPriority: isHighPriority
            }
        }
    }
}
